<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">寻访要求<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('寻访方向') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          寻访方向（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.寻访方向 || '暂无寻访方向' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('目标公司') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          目标公司（来自公司信息）（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <div class="mb10">
          <el-tag
            v-for="(item, index) in project.目标公司"
            :key="`${item}${index}`"
            style="margin-right:5px;"
            size="mini"
            >{{ item }}</el-tag
          >
        </div>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('不倾向公司') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          不倾向公司（来自公司信息）：
        </div>
        <div class="mb10">
          <el-tag
            v-for="(item, index) in project.不倾向公司"
            :key="`${item}${index}`"
            style="margin-right:5px;"
            size="mini"
            >{{ item }}</el-tag
          >
        </div>
      </div>
      <!-- <div class="project-detail-content">
        <div :class="[hasNotValueFields.includes('倾向平台') ? 'warning-text' : '', 'project-detail-content-title mb10']">倾向平台（来自公司信息）：</div>
        <div class="mb10">
          <el-tag
            v-for="(item, index) in project.倾向平台"
            :key="`${item}${index}`"
            style="margin-right:5px;"
            size="mini"
            >{{ item }}</el-tag
          >
        </div>
      </div> -->
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('典型人才') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          典型人才（来自公司信息）（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <div class="mb10">
          <el-tag
            v-for="(item, index) in typicalRadishes"
            :key="`${item}${index}`"
            style="margin-right:5px;"
            size="mini"
            @click="showRadish({ id: item._id })"
            >{{ item.姓名 }}</el-tag
          >
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">职位JD</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('寻访方向') ? 'warning-text' : '', 'field-label']"
            >寻访方向（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <div style="display:flex">
            <el-input
              v-model="projectInEdit.寻访方向"
              class="mb15"
              type="textarea"
              :rows="2"
              placeholder="请输入该职位的核心要求"
            ></el-input>
          </div>
        </div>
        <div class="card-content-textarea-item">
          <span
            :class="[hasNotValueFields.includes('目标公司') ? 'warning-text' : '', 'field-label']"
            style="margin-bottom:0"
            >目标公司（来自公司信息）（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）<i class="el-icon-circle-plus text-btn" @click="selectCompany('目标公司')" />
          </span>
          <div class="flex-row flex-wrap mb10">
            <span v-for="(value, i) in projectInEdit['目标公司']" :key="i" class="label_tag">{{ value }}</span>
          </div>
        </div>
        <div class="card-content-textarea-item">
          <span
            :class="[hasNotValueFields.includes('不倾向公司') ? 'warning-text' : '', 'field-label']"
            style="margin-bottom:0"
            >不倾向公司（来自公司信息）<i class="el-icon-circle-plus text-btn" @click="selectCompany('不倾向公司')" />
          </span>
          <div class="flex-row flex-wrap mb10">
            <span v-for="(value, i) in projectInEdit['不倾向公司']" :key="i" class="label_tag">{{ value }}</span>
          </div>
        </div>
        <!-- <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('倾向平台') ? 'warning-text' : '', 'field-label']" style="margin-bottom:0"
            >倾向平台（来自公司信息）<i class="el-icon-circle-plus text-btn" @click="openDialog" />
          </span>
          <div class="flex-row flex-wrap mb10">
            <span v-for="(value, i) in projectInEdit['倾向平台']" :key="i" class="label_tag">{{ value }}</span>
          </div>
        </div> -->
        <div class="card-content-textarea-item">
          <p
            :class="[hasNotValueFields.includes('典型人才') ? 'warning-text' : '', 'field-label']"
            style="margin-bottom:0"
          >
            <span
              >典型人才（来自公司信息）（1%<el-tooltip
                class="item"
                style="display:inline;color:#409EFF"
                effect="dark"
                content="业绩贡献率"
                placement="top"
                ><i class="el-icon-question"></i></el-tooltip
              >）</span
            >
            <el-popover v-model="typicalRadishVisible" placement="right" width="800" trigger="click">
              <div class="propject_detail_info_table col-1" style="max-height:70vh;font-size:14px;padding:10px">
                <p style="text-align:center;margin-bottom:20px" class="flex-row">
                  <el-input
                    v-model="typicalRadishKeyword"
                    size="mini"
                    placeholder="输入姓名进行搜索"
                    @keyup.enter.native="getTemporaryInterviewers(typicalRadishKeyword)"
                  ></el-input>
                  <el-button size="mini" type="primary" @click="getTemporaryInterviewers(typicalRadishKeyword)"
                    >搜索</el-button
                  >
                </p>
                <p class="mb10" style="color:#409EFF">点击选择一位典型人才(可多选)</p>
                <div v-if="typicalRadishLoading" class="loading-mask"><i class="el-icon-loading"></i></div>
                <div v-else>
                  <div class="flex-row project_table_thead item-center">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">公司</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">部门</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职能模块</span>
                  </div>
                  <div
                    v-for="(value, i) in temporaryTypicalRdish"
                    :key="`companyHr${i}`"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="chooseTypicalRadish(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['公司'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['部门'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">
                      <el-tag v-for="item in value['职能模块']" :key="item" size="mini" type="primary">{{
                        item
                      }}</el-tag>
                    </span>
                  </div>
                </div>
              </div>
              <span slot="reference"><i class="el-icon-circle-plus text-btn mb10"/></span>
              <!-- <a slot="reference"> <i class="el-icon-circle-plus mb10" /> </a> -->
              <!-- <i slot="reference" class="el-icon-circle-plus mb10 text-btn" /> -->
            </el-popover>
          </p>
          <!-- <a> 关键面试决策人（1%） <i class="el-icon-circle-plus mb10" /> </a> -->
          <div class="flex-row flex-wrap mb10">
            <span
              v-for="(value, i) in tempTypicalRadishes"
              :key="i"
              class="label_tag"
              @click="showRadish({ id: value._id })"
              >{{ value.姓名 }}</span
            >
          </div>
        </div>

        <!-- dialog -->
        <el-dialog title="选择平台" :visible.sync="dialogVisible" :close-on-click-modal="false" width="400px" top="18vh" :modal="false">
          <el-checkbox-group v-model="platform" style="text-align: left;width:100%" class="mb10">
            <el-checkbox v-for="i in 倾向平台" :key="i" :label="i" style="margin:0 10px 6px 0"></el-checkbox>
          </el-checkbox-group>
          <span slot="footer" class="dialog-footer">
            <span class="mr10">
              <el-button size="mini" type="danger" @click="dialogVisible = false">取 消</el-button>
            </span>
            <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>

    <!-- component -->
    <SelectCompany ref="SelectCompany" @confirm="addCompany"></SelectCompany>
  </el-card>
</template>
<script>
import SelectCompany from '../../../../company/src/hunting/selectCompany'
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import * as fixedvariant from '../../../../company/statistics/variant/fixedvariant'
import mixin from './mixin'

export default {
  components: { SelectCompany },
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      倾向平台: fixedvariant.公司用人偏好.平台,
      dialogVisible: false,
      platform: [],
      typicalRadishVisible: false,
      typicalRadishKeyword: '',
      typicalRadishLoading: false,
      temporaryTypicalRdish: [],
      typicalRadishes: [],
      componentType: '寻访要求',
      fields: ['寻访方向', '目标公司', '不倾向公司', '倾向平台', '典型人才'],
      tempTypicalRadishes: [],
    }
  },
  mounted() {
    this.$watch(
      function() {
        // 第一个函数就是处理你要监听的属性，只要将其return出去就行
        return this.project.典型人才
      },
      function(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.getTypicalRadish()
        }
      },
    )
  },
  methods: {
    // selectCompany(field) {
    //   window.app.root.$refs.targetCompany.show({
    //     defaultCompanies: this.project[field] || [],
    //     onConfirm: value => {
    //       this.$set(this.project,field,value)
    //     },
    //   })
    // },
    toEdit() {
      this.projectInEdit = {}
      this.fields.forEach(key => {
        const value =
          this.project[key] || (typeof defaultProject[key] === 'object' ? window._.cloneDeep(defaultProject[key]) : '')
        if (value && typeof value === 'object') {
          const newVal = JSON.parse(JSON.stringify(value))
          this.$set(this.projectInEdit, key, newVal)
        } else {
          this.$set(this.projectInEdit, key, value)
        }
      })
      this.tempTypicalRadishes = window._.cloneDeep(this.typicalRadishes || [])
      this.isEditing = true
      this.$emit('toEdit', this.componentType)
    },
    selectCompany(field) {
      this.companyField = field
      this.$refs.SelectCompany.open()
      // window.app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.project['目标公司'] || [],
      //   onConfirm: value => {
      //     this.updateProject({ 目标公司: value })
      //   },
      // })
    },
    addCompany(value) {
      if (this.companyField) this.$set(this.projectInEdit, this.companyField, value)
    },
    openDialog() {
      this.platform = window._.cloneDeep(this.projectInEdit.倾向平台 || [])
      this.dialogVisible = true
    },
    async onConfirm() {
      this.projectInEdit.倾向平台 = this.platform
      this.dialogVisible = false
    },
    async getTypicalRadish() {
      const ids = this.project['典型人才']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.typicalRadishes = res.data
      } else this.typicalRadishes = []
    },
    async getTempTypicalRadish() {
      const ids = this.projectInEdit['典型人才']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.tempTypicalRadishes = res.data
      } else this.tempTypicalRadishes = []
    },
    chooseTypicalRadish(radish) {
      if (!this.projectInEdit['典型人才']) this.$set(this.projectInEdit, '典型人才', [])
      if (!this.projectInEdit['典型人才'].includes(radish._id)) this.projectInEdit['典型人才'].push(radish._id)
      this.$message({ type: 'success', message: `添加成功` })
      this.getTempTypicalRadish()
      this.typicalRadishVisible = false
    },
    removeTypicalRadish(radish) {
      const index = this.tempTypicalRadishes.findIndex(_hrid => _hrid._id === radish._id)
      const idIndex = this.projectInEdit['关键面试人'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.projectInEdit['关键面试人'].splice(idIndex, 1)
      this.tempTypicalRadishes.splice(index, 1)
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async getTemporaryInterviewers(name) {
      this.typicalRadishLoading = true
      const res = await app.service('misc').searchEs({
        type: '人选',
        keywords: name,
        fields: ['姓名^5', '拼音', '公司^5', '职能模块', '手机'],
        and: true,
      })
      if (res.status === 'success') {
        this.temporaryTypicalRdish = res.data
        this.temporaryInterviewerKeyword = ''
        this.typicalRadishLoading = false
      } else this.$message.error(res.msg)
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
